export enum AUTH_ENUM {
  TOKEN_EXPIRE = "token_expires",
  LOGOUT = "logout",
  DISCOVERY_DOCUMENT_LOADED = "discovery_document_loaded",
  JWKS_LOAD_ERROR = "jwks_load_error",
  INVALID_NONCE_IN_STATE = "invalid_nonce_in_state",
  DISCOVERY_DOCUMENT_LOAD_ERROR = "discovery_document_load_error",
  DISCOVERY_DOCUMENT_VALIDATION_ERROR = "discovery_document_validation_error",
  USER_PROFILE_LOADED = "user_profile_loaded",
  USER_PROFILE_LOAD_ERROR = "user_profile_load_error",
  TOKEN_RECEIVED = "token_received",
  TOKEN_ERROR = "token_error",
  CODE_ERROR = "code_error",
  token_refreshed = "token_refreshed",
  TOKEN_REFRESH_ERROR = "token_refresh_error",
  SILENT_REFRESH_ERROR = "silent_refresh_error",
  SILENTLY_REFRESHED = "silently_refreshed",
  SILENT_REFRESH_TIMEOUT = "silent_refresh_timeout",
  TOKEN_VALIDATION_ERROR = "token_validation_error",
  TOKEN_EXPIRES = "token_expires",
  SESSION_CHANGED = "session_changed",
  SESSION_ERROR = "session_error",
  SESSION_TERMINATED = "session_terminated",
  SESSION_UNCHANGED = "session_unchanged",
  POPUP_CLOSED = "popup_closed",
  POPUP_BLOCKED = "popup_blocked",
  TOKEN_REVOKE_ERROR = "token_revoke_error",
}

export enum BRAND_MENU {
  FORD = "MyAREA",
  JAGUAR = "MyAREA",
  LAND_ROVER = "MyAREA",
  SUZUKI = "MyAREA",
  HONDA = "MyAREA",
  MY_ALD = "My ALD",
  ALD_AUTOMOTIVE = "My ALD",
  LYNKCO = "MyAREA",
  SMART = "MyAREA",
  FFM_FORD = "MyAREA",
  MY_AYVENS="My Ayvens",
  OMODA_JAECOO = "MyAREA",
  MG = "MyAREA",
  FFM="MyAREA"
}

export enum BRAND_CLIENT_SERVICE_NUMBER {
  MY_ALD = "800 426 426",
  FORD = "800 69 39 99",
  JAGUAR = "800 90 40 30",
  LAND_ROVER = "800 90 80 99",
  SUZUKI = "800 21 53 35 ",
  HONDA = "800 01 08 11",
  RICARICAR = "848 78 10 99",
  E_GO = "800 27 01 55",
  SMART = "800 01 08 11",
  LYNKCO = "800 95 09 40",
  OMODA_JAECOO = "800 31 54 27",
  MG = "800 189 995",
  FFM="800 800 868"
}

export enum BRAND_ROAD_SIDE_NUMBER {
  MY_ALD = "800 826 001",
  FORD = "800 25 64 68",
  JAGUAR = "800 10 43 40",
  LAND_ROVER = "800 10 43 40",
  SUZUKI = "800 19 14 72",
  HONDA = "800 110 163",
  OMODA_JAECOO = "800 31 54 27",
  MG = "800 189 995",
  FFM="800 25 64 68"
}

export enum BRAND {
  FORD = "ford.mobilitysolutions.it",
  MAZDA = "https://mazda.mobilitysolutions.it",
  JAGUAR = "https://jaguar.mobilitysolutions.it",
  LAND_ROVER = "https://landrover.mobilitysolutions.it",
  UBI = "https://ubi.mobilitysolutions.it",
  SUZUKI = "https://suzuki.mobilitysolutions.it",
  HONDA = "https://honda.mobilitysolutions.it",
  FFM_FORD = "https://fordfleetmanagement.mobilitysolutions.it",
  OMODA_JAECOO = "https://omodajaecoo.mobilitysolutions.it",
  MG = "https://mg.mobilitysolutions.it",
  FFM = "https://ffm.mobilitysolutions.it"
}

export enum BRAND_PATH {
  FORD = "assets/img/brand-image/ford.png",
  JAGUAR = "assets/img/brand-image/jaguar.png",
  LAND_ROVER = "assets/img/brand-image/landrover.png",
  SUZUKI = "assets/img/brand-image/suzuki.png",
  HONDA = "assets/img/brand-image/honda.png",
  //MY_ALD = "assets/img/brand-image/myald.png",
  ALD_AUTOMOTIVE = "assets/img/brand-image/aldautomotive.png",
  LYNKCO = "assets/img/brand-image/lynkco.png",
  SMART = "assets/img/brand-image/smart.png",
  FFM_FORD = "assets/img/brand-image/ffm_old.png",
  OMODA_JAECOO = "assets/img/brand-image/omodajaecoo.png",
  MG = "assets/img/brand-image/mg.png",
  FFM = "assets/img/brand-image/ffm.png",
  MY_AYVENS = "assets/img/brand-image/myayvens.png",
  AYVENS="assets/img/brand-image/ayvens.png",

}


export enum BRAND_FAVICON {
  FORD = "assets/img/brand-image/favicon/ford.ico",
  JAGUAR = "assets/img/brand-image/favicon/jaguar.ico",
  LAND_ROVER = "assets/img/brand-image/favicon/landrover.ico",
  SUZUKI = "assets/img/brand-image/favicon/suzuki.ico",
  HONDA = "assets/img/brand-image/favicon/honda.ico",
  MY_ALD = "assets/img/brand-image/favicon/myald.ico",
 // ALD_AUTOMOTIVE = "assets/img/brand-image/favicon/aldautomotive.ico",
  AYVENS = "assets/img/brand-image/favicon/ayvens.ico",
  LYNKCO = "assets/img/brand-image/favicon/lynkco.ico",
  SMART = "assets/img/brand-image/favicon/smart.ico",
  FFM_FORD = "assets/img/brand-image/favicon/ford.ico",
  OMODA_JAECOO = "assets/img/brand-image/omodajaecoo.ico",
  MG = "assets/img/brand-image/mg.ico",
  FFM = "assets/img/brand-image/favicon/ffm-favicon.ico"
}